import axios from "axios";

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/bulk`
  };
  return axios(config);
}

export function fetchShopInfo(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`
  };
  return axios(config);
}

export function fetchShopEdit(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`
  };
  return axios(config);
}

export function fetchSiAccounts() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/si-accounts`
  };
  return axios(config);
}

export function fetchQrcode(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}/qrcode`
  };
  return axios(config);
}

export function fetchRichmenus() {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/richmenus`
  };
  return axios(configBusiness);
}

export function fetchManagerInfo(siAccountId, type, bType, id) {
  console.log(siAccountId, type, bType, id);
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/${type}/si-accounts/${siAccountId}?type=${bType}&businessId=${id}`
  };
  return axios(configBusiness);
}
